<template>
  <div>
    <div class="edit-product">
      <div class="breadcrumb" style="background: #fff">编辑SKU信息</div>
      <div class="third-title"><span>基础设置</span></div>
      <el-form ref="form" :model="form" label-width="100px" style="padding:30px 0 0 100px">
        <el-form-item label="sku名字:">
          <el-input v-model="skuVo.skuName" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="合成尺寸:">
          <el-table :data="addSkuFrom.sizeTable" style="width: 500px;margin:0 0 0 0" border :row-class-name="rowClassName">
            <el-table-column label="合成尺寸类型" min-width="100px" prop="sizeType"></el-table-column>
            <el-table-column label="数量" min-width="100px">
              <template v-slot="scope">
                <span v-show="!scope.row.change">{{scope.row.num}}</span>
                <el-input style="width:90%;" v-show="scope.row.change" v-model="scope.row.num" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="基础P数:">
          {{skuVo.basePage}}
        </el-form-item>
        <el-form-item label="一次增加P数:">
          <el-input v-model="skuVo.stepLength" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="最大P数:">
          <el-input v-model="skuVo.maxPage" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="基础P价格:">
          <el-input v-model="skuVo.minStorePrice" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="增加一次价格:">
          <el-input v-model="skuVo.stepStorePrice" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-button style="margin:0 0 0 950px" @click="addSku" round type="primary">创建</el-button>
    </div>
  </div>
</template>
 <script>
export default {
  data () {
    return {
      addSkuFrom: {
        sizeTable: [{
          sizeType: '封面',
          num: 1,
          change: false
        }, {
          sizeType: '内页',
          num: 10,
          change: true
        }]
      },
      skuVo: {
        skuGroupId: 15,
        basePage: 10,
        maxPage: 20,
        minStorePrice: 100,
        skuName: '',
        stepLength: 2,
        stepStorePrice: 10,
        storePrice: 2000,
        stepSalePrice: 20,
        minSalePrice: 100,
        salePrice: 100,
        spuId: this.$route.query.id
      }
    }
  }
}
</script>
 <style>
</style>
